export default {
  projectId: null,
  loadGeneration: 0,

  accountAvailable: false,
  accountLoaded: false,
  account: null,
  accountLoading: false,
  accountError: '',

  achAvailable: false,
  fundingMethod: null,
  achLoading: false,
  achError: ''
}
